import React, {useContext, useState} from 'react'
import {StateContext} from "../../context/GlobalState.jsx";
import {Col, Container, Row} from "react-bootstrap";
import Pages from "../Pagination/Pagination.jsx";
import PagesURL from "../Pagination/PaginationURL.jsx";
import {Helmet} from "react-helmet";
import {GetText} from "../../context/text";



function Filter(props) {

    let text = GetText();
    let {models} = useContext(StateContext);
    let caterogy = "";

    const [modelId, setModelId] = useState(0);



   const filterModel = (ids) => {
       setModelId(ids);
   }

    // Функція для пошуку NAME_GROUP по ID
    const getNameGroupById = (id) => {
        const model = models.find(item => item.ID === id.toString()); // Використовуємо toString(), щоб порівняти як рядки
        return model ? model.NAME_GROUP : null;  // Якщо модель знайдена, повертаємо NAME_GROUP, в іншому випадку null
    }

    if(modelId)
    {
        caterogy = text.ProductItem.Category + getNameGroupById(modelId);
    }
    else
    {
        caterogy = text.ProductItem.selCategory;

    }

    return (
        <div>
            <Helmet>
                <title>{text.Catalog.title + ' - ' + text.Header.name} - zapauto.com.ua</title>
                <meta name="description" content={
                    text.Catalog.title + ": " + models.map((model) => model.NAME_GROUP + " ")}/>
                <meta name="keywords"
                      content={ models.map((model) => model.NAME_GROUP + " ") } />
            </Helmet>
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>

                        <div className="cars">
                            <Container>
                                <Row>
                                    <p><b>{caterogy}</b></p>

                                    {
                                        models.map((model, i) => <Col xs={6} sm={4} md={2} >

                                                <button className="add-cart-btn full-width"    onClick={() => filterModel(model.ID)} >{model.NAME_GROUP}</button>

                                        </Col>)
                                    }

                                </Row>
                            </Container>
                        </div>


                    </Col>
                </Row>
            </Container>
            {modelId ? (props.pageURL ? <PagesURL pageURL={props.pageURL} /> : <Pages modelId={modelId}  />) : ""}
        </div>
    )
}

export default Filter
